
import Navigation from '@/components/Navigation/Navigation.vue';
import Home from '../components/Home/Home.vue';
import SkillsBorder from '@/components/SkillsBorder/SkillsBorder.vue';
import AboutMe from '@/components/AboutMe/AboutMe.vue';
import Contact from '@/components/Contact/Contact.vue';
import Footer from '@/components/Footer/Footer.vue';
import Projects from '@/components/Projects/Projects.vue';

export default {
  name: 'FullPage',
  components: {
    Navigation,
    Home,
    SkillsBorder,
    AboutMe,
    Contact,
    Footer,
    Projects,
  },
};